import type { TFieldType } from '../types/custom-field-definition';

export const CustomFieldTypes: Record<TFieldType, string> = {
  NUMBER: 'customFieldsDefinitionsPage.fieldTypes.NUMBER',
  TEXT: 'customFieldsDefinitionsPage.fieldTypes.TEXT',
  RICHTEXT: 'customFieldsDefinitionsPage.fieldTypes.RICHTEXT',
  FORMULA: 'customFieldsDefinitionsPage.fieldTypes.FORMULA',
  BOOLEAN: 'customFieldsDefinitionsPage.fieldTypes.BOOLEAN',
  ARRAY: 'customFieldsDefinitionsPage.fieldTypes.ARRAY',
  TABLE: 'customFieldsDefinitionsPage.fieldTypes.TABLE',
  DATE: 'customFieldsDefinitionsPage.fieldTypes.DATE'
};
